import { createReducer, on } from '@ngrx/store';
import { setUser, deleteUser, setAccessMode, setUserExtraParam, removeUserExtraParam, removeAllUserExtraParams } from './user.actions';
import { SessionInfo } from '@/app/api/UserPrefs-dto';

// Initial state is a new SessionInfo object
const initialState = new SessionInfo();

export const reducer = createReducer<SessionInfo>(
  initialState,
  on(deleteUser, () => new SessionInfo()),
  on(setUser, (state, { payload }) => {
    if (payload.sessionInfo && state) {
      // Mantenemos los datos de modoAcceso y extraParams
      payload.sessionInfo.modoAcceso = state.modoAcceso;
      payload.sessionInfo.extraParams = state.extraParams;
    }
    return payload.sessionInfo ? payload.sessionInfo : state;
  }),
  on(setAccessMode, (state, { payload }) => {
    // Immutability improvement over original: return new object
    const sess = structuredClone(state);
    sess.modoAcceso = payload.modoAcceso;
    return sess;
  }),
  on(setUserExtraParam, (state, { payload }) => {
    const newState = structuredClone(state);
    // Ensure extraParams exists
    if (!newState.extraParams) {
      newState.extraParams = {};
    }
    newState.extraParams[payload.key] = payload.value;
    return newState;
  }),
  on(removeUserExtraParam, (state, { payload }) => {
    const newState = structuredClone(state);
    if (newState.extraParams) {
      delete newState.extraParams[payload.key];
    }
    return newState;
  }),
  on(removeAllUserExtraParams, (state) => {
    const newState = structuredClone(state);
    delete newState.extraParams;
    return newState;
  })
);
